import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import type { AuditLogActionEnum } from '@repo/api-contract';
import TimelineDot from '@mui/lab/TimelineDot';

export function getAuditActionIcon(action: AuditLogActionEnum): JSX.Element {
  switch (action) {
    case 'create':
      return (
        <TimelineDot color="primary">
          <AddCircleOutlineIcon />
        </TimelineDot>
      );

    case 'update':
      return (
        <TimelineDot color="primary">
          <EditIcon />
        </TimelineDot>
      );

    case 'delete':
      return (
        <TimelineDot color="error">
          <DeleteOutlineIcon />
        </TimelineDot>
      );

    case 'invoice-void':
      return (
        <TimelineDot color="warning">
          <CancelOutlinedIcon />
        </TimelineDot>
      );

    case 'po-associated':
      return (
        <TimelineDot color="primary">
          <LinkOutlinedIcon />
        </TimelineDot>
      );

    default:
      return (
        <TimelineDot color="primary">
          <HelpOutlineIcon />
        </TimelineDot>
      );
  }
}

export const formatAction = (action: string) =>
  action.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase());
